module.exports = __webpack_public_path__ + "media/intro-portrait.b4768c42.webm";